<div class="locataires-page">
  <a [routerLink]="routes.locataires" class="locataires-back">
    <fa-icon icon="arrow-left"></fa-icon>
    {{ 'common.backToList' | translate }}
  </a>

  <header class="locataires-header">
    <div>
      <h2 class="locataires-title">{{ 'locataires.ajout.title' | translate }}</h2>
      <p class="locataires-subtitle">{{ 'locataires.ajout.subtitle' | translate }}</p>
    </div>
  </header>

  @if (loadingLogements) {
    <p class="locataires-status">{{ 'common.loading' | translate }}</p>
  }

  @if (logementsError) {
    <p class="locataires-status locataires-status--error">
      {{ 'locataires.ajout.logementsLoadError' | translate }}
    </p>
  }

  @if (!loadingLogements && !logementsError && logements.length === 0) {
    <p class="locataires-empty">
      {{ 'locataires.ajout.noLogement' | translate }}
      <a [routerLink]="routes.logements">{{ 'nav.logements' | translate }}</a>
    </p>
  }

  @if (!loadingLogements && !logementsError && logements.length > 0) {
    <form class="locataires-form" (ngSubmit)="submit()" [formGroup]="form">
      <app-locataire-form-fields
        [form]="form"
        [logements]="logements"
        [selectedMeuble]="selectedMeuble"
        [dureeBailHintKey]="dureeBailHintKey"
        [dureeBailErrorKey]="dureeBailErrorKey"
        [dureeBailInvalid]="dureeBailInvalid"
        />

      @if (error) {
        <p class="locataires-status locataires-status--error">
          {{ 'locataires.ajout.saveError' | translate }}
        </p>
      }

      <div class="locataires-form-actions">
        <a [routerLink]="routes.locataires" class="locataires-cancel">{{
          'common.cancel' | translate
        }}</a>
        <button type="submit" class="locataires-action-btn" [disabled]="saving">
          {{
            saving
              ? ('common.saving' | translate)
              : ('common.save' | translate)
          }}
        </button>
      </div>
    </form>
  }
</div>
